<template>
  <div class="no-data-layer">
    <template v-if="isNoData">
      <div class="no-data-layer__no-data">
        {{L10n('no-data')}}
      </div>
    </template>
    <template v-else>
      <div class="no-data-layer__content">
        <slot />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  props: {
    isNoData: { type: Boolean, default: false }
  }
}
</script>

<style lang="stylus">
  .no-data-layer {
    &__no-data {
      min-height 20rem
      font-weight 700
      color #ccc
      text-transform uppercase
      opacity 0.7
      display flex
      align-items center
      justify-content center
      text-align center
    }
    &__content {
      height 100%
    }
  }
</style>
